import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { environment } from '../environment/EnvironmentStatic';
import { RootState } from './Types';

export const apiParams = {
	paths: {
		companies: '/api/company/list',
		countries: '/api/country/list',
		currencies: '/api/currency/list',
		products: '/api/product/list',
		dealer: {
			list: '/api/dealer/list',
			invoice: '/api/dealer/invoice',
		},
		invoice: {
			excel: '/api/invoice/download',
			prepare: '/api/invoice/prepare',
			generate: '/api/invoice/generate',
			summary: '/api/invoice/summary',
			market: '/api/invoice/market',
			dealer: '/api/invoice/dealer',
		},
		countryDealers: '/api/dealer/list/country/',
		marketCompanyDealers: '/api/dealer/list/market-company/',
		dealerClasses: '/api/dealer-class/list',
		contract: {
			distinct: '/api/contract/distinct'
		},
		parts: '/parts',
		orderLines: '/order-lines',
		orders: '/orders',
		users: '/users',
	},
	methods: {
		POST: 'POST',
		DELETE: 'DELETE',
		PATCH: 'PATCH',
	},
	tags: {
		parts: 'Parts',
		orderLines: 'Order lines',
		shoppingCart: 'Shopping cart',
		orders: 'Orders',
		orderDetails: 'Order details',
	},
};

export const apiSlice = createApi({
	reducerPath: 'api',
	tagTypes: Object.values(apiParams.tags),
	baseQuery: fetchBaseQuery({
		baseUrl: environment().api,
		prepareHeaders: (headers, { getState }) => {
			const jwtToken = (getState() as RootState).security.accessToken;

			if (jwtToken) {
				headers.set('Authorization', `Bearer ${jwtToken}`);
			} else {
				console.error('Authorization header error(token)');
			}

			return headers;
		},
	}),

	endpoints: () => ({}),
});
